export default __webpack_public_path__ + "static/media/logo-us-carters.3334512a.svg";